export default {
  // ========== Matrix3View - Titles and texts ==========
  tributationOf: 'Contribution of',
  to: 'to the',
  definition: 'Definition:',
  planLevel: 'Plan Level',
  goTo: 'Go to',
  viewDetails: 'View Details',
  editSubjectsOfCompetence: 'Edit Subjects of Competence',
  competence: 'Competence:',
  closed: '(Closed)',
  updated: 'updated',
  planOf: 'Plan of',
  level: 'Level',
  total: 'Total',
  totalCompetencesTooltip: 'Number of {competences} each {matter} contributes to',
  noCompetencesThatContribute: 'There are no {competences} that contribute to this {egressProfile}.',
  without: 'without',
  with: 'with',
  selected: 'selected',

  // ========== Specific messages ==========
  selectSubjectsThatContribute: 'Select the {subjects} that contribute to this {competence}',

  // ========== AI Features ==========
  suggestTributationWithAI: 'Contribution suggestions from {entity1} to {entity2} with AI',
  suggestTributation: 'Contribution suggestions from {entity1} to {entity2}',
  suggestTributationDemo: 'Suggest Contribution',
  analyzeCurriculumCoherenceWithAI: 'Analyze curriculum coherence with AI',
  analyzeCurriculumCoherenceDemo: 'Analyze Curriculum Coherence',
  loadingSuggestions: 'Loading suggestions',
  regenerating: 'Regenerating',
  regenerateSuggestions: 'Regenerate Suggestions',
  generatingSuggestions: 'Generating contribution suggestions',
  tributationSuggestions: 'Contribution Suggestions',
  printSuggestionsReport: 'Print suggestions report',
  print: 'Print',
  curriculumCoherenceAnalysis: 'Curriculum Coherence Analysis',
  loadingAnalysis: 'Loading analysis',
  regenerateAnalysis: 'Regenerate Analysis',
  analysisParameters: 'Analysis Parameters',
  temperatureCreativity: 'Temperature (Creativity)',
  maxTokens: 'Maximum tokens',
  recommendedPreciseAnalysis: 'Recommended: 0.2 for precise and coherent analysis',
  recommendedCompleteAnalysis: 'Recommended: 2000-6000 for complete analysis',
  generatingAnalysis: 'Generating analysis',
  analysisResult: 'Analysis Result',
  printAnalysisReport: 'Print analysis report',
  cancelGeneration: 'Cancel Generation',
  analysisInProgress: 'Analysis generation is in progress. Do you want to cancel and close the modal?',
  suggestionsInProgress: 'Suggestions generation is in progress. Do you want to cancel and close the modal?',
  yesCancel: 'Yes, cancel',
  noContinue: 'No, continue',
  maxLengthReached: 'Generation reached the maximum length limit. {type} may be incomplete',
  contentFiltered: 'Content was filtered as inappropriate',
  couldNotDetermineResult: 'Could not determine a complete result. {action} again',
  adjustParametersAndRetry: 'Adjust parameters and try again',
  retry: 'Try again',
  errorGenerating: 'An error occurred while generating {type}. Please try again',
  theAnalysis: 'the analysis',
  theSuggestions: 'the suggestions',
  analysis: 'Analysis',
  suggestions: 'Suggestions',
  analysisMayBeIncomplete: 'The analysis shown may be incomplete',
  suggestionsMayBeIncomplete: 'The suggestions shown may be incomplete',
}
